import { render } from "./SetTestVersionModal.vue?vue&type=template&id=ae7aaf00&scoped=true"
import script from "./SetTestVersionModal.js?vue&type=script&lang=js"
export * from "./SetTestVersionModal.js?vue&type=script&lang=js"

import "./SetTestVersionModal.vue?vue&type=style&index=0&id=ae7aaf00&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7aaf00"]])

export default __exports__